import { Component, computed, inject, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { SharedModule } from "@shared/shared.module";
import { toSignal } from "@angular/core/rxjs-interop";
import { map } from "rxjs";

export interface IStatusHistoryRow {
    TaxReturn?: {
        Name?: string;
    };
    statusDate: number | null;
    userName: string;
    hide: boolean;
}

const DATE_FORMAT_EN_CA = "yyyy-MM-dd h:mm a";
const DATE_FORMAT_FR_CA = "yyyy-MM-dd H:mm";

@Component({
    selector: "wk-status-history",
    imports: [CommonModule, TranslateModule, JumpstartComponentsModule, SharedModule],
    templateUrl: "./status-history.component.html",
    styleUrl: "./status-history.component.scss",
})
export class StatusHistoryComponent {
    private readonly translateService = inject(TranslateService);

    protected statuses = input.required<IStatusHistoryRow[]>();
    protected showReturnHistoryTooltips = false;
    protected currentLang = toSignal(this.translateService.onLangChange.pipe(map((langChangeEvent) => langChangeEvent.lang)), {
        initialValue: this.translateService.getCurrentLang() ?? "en-CA",
    });
    protected dateFormat = computed<string>(() => (this.currentLang() === "fr-CA" ? DATE_FORMAT_FR_CA : DATE_FORMAT_EN_CA));

    showTooltip(event: FocusEvent): void {
        const element = event.target as HTMLElement;
        if (element?.nodeName === "DIV") {
            if (element.offsetWidth < element.scrollWidth) {
                this.showReturnHistoryTooltips = true;
                element.style.cursor = "pointer";
            } else {
                this.showReturnHistoryTooltips = false;
            }
        }
    }
}
